<template>
    <div>
        <hero-section></hero-section>
        <who-we-are></who-we-are>
        <careers-hero></careers-hero>
        <working-at-prospira></working-at-prospira>
        <environment-hero></environment-hero>
        <environment-policy></environment-policy>
        <safety-hero></safety-hero>
        <safety-policy></safety-policy>
        <quality-hero></quality-hero>
        <quality-policy></quality-policy>
    </div>
</template>

<script>
import CareersHero from '../components/CareersHero'
import HeroSection from '../components/HeroSection'
import WhoWeAre from '../components/WhoWeAre'
import WorkingAtProspira from '../components/WorkingAtProspira'
import EnvironmentHero from '../components/EnvironmentHero'
import EnvironmentPolicy from '../components/EnvironmentPolicy'
import SafetyHero from '../components/SafetyHero'
import SafetyPolicy from '../components/SafetyPolicy'
import QualityHero from '../components/QualityHero'
import QualityPolicy from '../components/QualityPolicy'

export default {
    name: 'IndexView',

    components: {
        'hero-section': HeroSection,
        'who-we-are': WhoWeAre,
        'careers-hero': CareersHero,
        'working-at-prospira': WorkingAtProspira,
        'environment-hero': EnvironmentHero,
        'environment-policy': EnvironmentPolicy,
        'safety-hero': SafetyHero,
        'safety-policy': SafetyPolicy,
        'quality-hero': QualityHero,
        'quality-policy': QualityPolicy
    }
}
</script>